<div class="container">
<br />
    <div class="row">
      <div class="col-md-10 offset-md-1">
          <b>
      Welcome to the Clerk of the Board Assessment Appeals Online Services Page. Use the links below to search for the status of a current assessment appeal case,
      view the current agenda of the Assessment Appeals Board or to view Assessment Appeals Board meeting minutes.
          </b>
      </div>
    </div>
  <br />
    <div class="row">
      <div class="col-md-4">
          <p><a class="btn btn-sm btn-primary" (click)="goSearch();">Search &raquo;</a></p>
          <p>
              Look up the current status of your Assessment Appeals case by applicant name, assessor's parcel number (APN),
              property situs (address), or appeals case number.
          </p>
      </div>
      <div class="col-md-4">
          <p><a class="btn btn-sm btn-primary" (click)="goAgenda();" >Agenda &raquo;</a></p>
          <p>View agenda for upcoming Assessment Appeals Board hearings.</p>
      </div>
      <div class="col-md-4">
          <p><a class="btn btn-sm btn-primary" (click)="goMinutes()">Minutes &raquo;</a></p>
          <p>View the official minutes from previous Assessment Appeals Board hearings.</p>
      </div>
    </div>
  <br />

</div>
<br />
<div class="row">
  <div class=col-md-2>
    &nbsp;
  </div>
  <div class="col-md-8" style="text-align:center">

    <img src="/assets/sbseal-clear.png" alt="County Seal" height="168" width="180">
  </div>
  <div class=col-md-2>
    &nbsp;
  </div>
</div>


